import React, { useState } from "react";
import { useHistory } from "react-router";
import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { updateChecklistThunk } from "../checklistSlice";
import { ChecklistStatusEnum } from "../constants";
import { setShowSuccessMessageThunk } from "../../../../global/globalSlice";

const ChecklistRemove: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const project = useAppSelector((state) => state.adminReducer.project);
  const checklist = useAppSelector((state) => state.checklistReducer.checklist);
  const [removeModalOpen, setRemoveModalOpen] = useState<boolean>(false);
  const [removeNameCheck, setRemoveNameCheck] = useState<string>("");

  const openModal = () => {
    setRemoveNameCheck("");
    setRemoveModalOpen(true);
  };

  const removeChecklist = async () => {
    dispatch(updateChecklistThunk("status", ChecklistStatusEnum.REMOVED, checklist.status));
    dispatch(setShowSuccessMessageThunk("Slettet"));

    setRemoveModalOpen(false);
    history.push(`/project/${project._id}/checklist`);
  };

  return (
    <>
      <Card>
        <CardBody>
          <CardTitle tag="h3">Slett {checklist.isTemplate === true ? "mal" : "sjekkliste"}</CardTitle>
          <CardSubtitle tag="h6" className="mb-2 text-muted" />
          <Button color="danger" onClick={openModal} disabled={disabled}>
            <i className="fa fa-remove fa-fw" />
            Slett
          </Button>
        </CardBody>
      </Card>
      <Modal isOpen={removeModalOpen} toggle={() => setRemoveModalOpen(!removeModalOpen)}>
        <ModalHeader toggle={() => setRemoveModalOpen(!removeModalOpen)}>Slett {checklist.name}</ModalHeader>
        <ModalBody>
          <div>Bekreft navnet på {checklist.isTemplate === true ? "malen" : "sjekklisten"} som skal slettes</div>
          <div>
            <Input value={removeNameCheck} onChange={(e) => setRemoveNameCheck(e.target.value)} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            disabled={removeNameCheck.toLocaleLowerCase() !== checklist.name.toLocaleLowerCase()}
            onClick={removeChecklist}
          >
            <i className="fa fa-trash fa-fw" />
            Slett
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ChecklistRemove;
